import axios, { AxiosResponse } from 'axios';
import { mutate } from 'swr';

import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { withQueryParams } from '@shared/commonFunctions';
import { Notistack } from '@shared/components/Notistack/Notistack';

import { IDocumentGenerate, IDocuSign } from './interface';

const path = `/${SERVICES.DOCUMENT}`;

export const requestDocumentGenerate = (data: IDocumentGenerate) => {
  const url = `${path}/documents/generate`;
  return mutate(url, async () => {
    try {
      const response = await axios.post(url, data);
      return String(response.status);
    } catch (err) {
      const error = err as { response: { data: { details: string } } };
      const details = error?.response?.data?.details || '';
      if (!details.includes('Error Contracting Products') || !details.includes('Envelope exists')) {
        Notistack.generalError(getError(err));
      }
      return details;
    }
  });
};

export const requestToGeneratePdf = (dealId: string, documentGeneratedType: number) => {
  const url = withQueryParams(`${path}/documents/${dealId}/generated`, { documentGeneratedType }, false);
  return mutate(url, async () => {
    try {
      const resp = await axios.get(url);
      return resp.data;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDocuSign = (data: IDocuSign) => {
  const url = `${path}/esignature/documents/send`;
  return mutate(url, async () => {
    try {
      await axios.post(url, data);
      Notistack.infoMessage('Sent to DocuSign');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDocumentValidate = (dealId: string) => {
  const url = `${path}/esignature/documents/${dealId}/validate`;
  return mutate(url, async () => {
    try {
      const resp = await axios.post(url);
      return resp;
    } catch (err) {
      Notistack.generalError(getError(err));
      return err;
    }
  });
};

export const requestDocumentValidateEnvelope = (dealId: string) => {
  const url = `${path}/esignature/documents/${dealId}/validateforenvelope`;
  return mutate(url, async () => {
    try {
      const resp: AxiosResponse<boolean> = await axios.post(url);
      return resp?.data ?? false;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDocumentVoid = (dealId: string) => {
  const url = `${path}/esignature/documents/${dealId}/void`;
  return mutate(url, async () => {
    try {
      const resp = await axios.post(url);
      return resp;
    } catch (err) {
      Notistack.generalError(getError(err));
      return err;
    }
  });
};
